import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'

export default (props) => <RedirectTemplate location={props.location} destination="/tv/" />

// import React from 'react'
// import USTemplateDefault from 'src/components/template/us'
// import { appleTVPromoBanner } from 'src/constants/promoBannerData'
// import { promoCodes } from 'src/constants/promoCodes'
// import { commonCtaText } from 'src/modules/utils/constants'

// export default (props) => {
//   return (
//     <USTemplateDefault
//       location={props.location}
//       lang="en"
//       market="us"
//       title={
//         <>
//           Get a FREE <br />
//           Apple TV 4K
//         </>
//       }
//       subtitle={
//         <>
//           $129 value. With Fubo Elite subscription.{' '}
//           <span className="desktop-line-break">Terms & conditions apply.</span>
//         </>
//       }
//       offerCode={promoCodes.apple_tv_4k}
//       showRSN={true}
//       ctaText={commonCtaText.startWatchingForFree}
//       additionalFAQs={additionalFAQs}
//       {...appleTVPromoBanner}
//     />
//   )
// }

// const additionalFAQs = [
//   {
//     question: 'What is the Apple TV 4K offer from Fubo?',
//     answer:
//       'Eligible new subscribers to the Fubo Elite plan can get a free Apple TV 4K ($129 value) when they commit to keeping their subscription active for 6 months. The Apple TV 4K device is yours to keep once the commitment ends, at no extra charge. Not available in Hawaii, Alaska or Puerto Rico. Offer valid while supplies last.',
//   },
//   {
//     question: 'How do I claim the Apple TV 4K offer?',
//     answer:
//       "Just opt in when signing up for the Fubo Elite plan (if presented with the offer). After your free trial and first payment, you'll get an email confirming your Apple TV 4K order.",
//   },
//   {
//     question: 'Can I decline the Apple TV 4K offer?',
//     answer:
//       'Yes. You can choose to continue with a standard subscription without receiving an Apple TV 4K device.',
//   },
//   {
//     question: 'What happens if I cancel my Fubo subscription before 6 months?',
//     answer:
//       "If you cancel your Fubo subscription while still in a trial, you won't be charged, but you won't receive the Apple TV 4K. If you cancel after your trial, but within 6 months, you'll be charged $129 (plus tax) for the device.",
//   },
//   {
//     question: 'When will my Apple TV 4K ship?',
//     answer:
//       "7 days after your first Fubo subscription payment, you'll receive an email confirming your Apple TV 4K order. The device will ship within 5 business days after that. (Delivery times may vary.)",
//   },
//   {
//     question: 'Can I use the Apple TV 4K to stream other apps?',
//     answer:
//       'Yes, your Apple TV 4K can stream other TV apps, not just Fubo. (Subscriptions may be required.)',
//   },
// ]
